export default __webpack_public_path__ + "media/join-game.1578d5bf.png";